// extracted by mini-css-extract-plugin
module.exports = {"dataLabel":"common_dataLabel__lSlfi","value":"common_value__2pOtY","loadingWrapper":"common_loadingWrapper__1fhPc"};